import OTPForm from "./OTPForm";
export default OTPForm;
